import { BUILDING_CATEGORIES } from "@/game-palworld/constants/buildings.mjs";
import { ITEM_CATEGORIES } from "@/game-palworld/constants/items.mjs";
import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import lazyFn from "@/util/lazy-fn.mjs";
import pathRegExp from "@/util/path-regexp.mjs";

const fetchStaticData = lazyFn(
  () => import("@/game-palworld/fetches/fetch-static-data.mjs"),
);
const fetchMapData = lazyFn(
  () => import("@/game-palworld/fetches/fetch-map-data.mjs"),
);
const fetchPalData = lazyFn(
  () => import("@/game-palworld/fetches/fetch-pal-data.mjs"),
);

const buildingCategories = Object.keys(BUILDING_CATEGORIES).join("|");
const itemCategories = Object.keys(ITEM_CATEGORIES).join("|");
const routes: BaseRoute[] = [
  {
    path: pathRegExp("/palworld/database/key-items{/:keyItem}?"),
    redirect: (route) => route?.currentPath.replace("key-items", "keyItems"),
  },
  {
    path: pathRegExp(
      `/palworld/database/:category(${itemCategories}){/:itemId}?`,
    ),
    component: "game-palworld/Items.tsx",
  },
  {
    path: pathRegExp("/palworld/database/pals/:pal"),
    component: "game-palworld/Pal.tsx",
    fetchData: fetchPalData,
  },
  {
    path: "/palworld/database/pals",
    component: "game-palworld/PalsLanding.tsx",
  },
  {
    path: pathRegExp(
      `/palworld/database/buildings/:category(${buildingCategories}){/:buildingId}?`,
    ),
    component: "game-palworld/Buildings.tsx",
  },
  {
    path: "/palworld/database",
    component: "game-palworld/DatabaseLanding.tsx",
  },
  {
    path: pathRegExp("/palworld/database/technology{/:technology}?"),
    component: "game-palworld/Technology.tsx",
  },
  {
    path: "/palworld/breeding-calculator",
    component: "game-palworld/BreedingCalculator.tsx",
  },
  {
    path: "/palworld/database/passives",
    component: "game-palworld/PassivesLanding.tsx",
  },
  {
    path: "/palworld/map",
    component: "game-palworld/InteractiveMap.tsx",
    fetchData: fetchMapData,
  },
  {
    path: "/palworld/interactive-map",
    redirect: "/palworld/map",
  },
  {
    path: "/palworld/tier-list",
    redirect: "/palworld/tier-list/combat",
  },
  {
    path: pathRegExp("/palworld/tier-list/:list(combat|base|mount)"),
    component: "game-palworld/TierList.tsx",
  },
];

// The catch-all route should be used for fetching any general static data that is
// related to the routes.
routes.push({
  [catchAllRoutes]: routes,
  fetchData: fetchStaticData,
});

export default routes;
